
import React, { useState, useRef, useEffect } from 'react';
import DishPreview from "./Bulid_menu/DishPreview";
import { menuItems, menuStructure } from "./Bulid_menu/buildMenuData";
import { useHistory } from "react-router-dom";

const BuildMenu = () => {
  const [selectedItems, setSelectedItems] = useState([]);
  const scrollRefs = useRef({});
  const history = useHistory();

  useEffect(() => {
    document.body.style.overflow = "auto";
    window.scrollTo(0, 0);
  }, []);

  const scroll = (category, direction) => {
    const container = scrollRefs.current[category];
    if (container) {
      const scrollAmount = 300;
      container.scrollBy({ left: direction === 'left' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
    }
  };


  const toggleItem = (item) => {
    setSelectedItems((prev) =>
      prev.some((i) => i.id === item.id)
        ? prev.filter((i) => i.id !== item.id)
        : [...prev, item]
    );
  };

  const removeFromDish = (id) => {
    setSelectedItems((prev) => prev.filter((i) => i.id !== id));
  };

  const clearDish = () => setSelectedItems([]);

  // CORRECTED REORDER LOGIC
  const reorderItems = (draggedId, targetId) => {
    setSelectedItems((prev) => {
      const newItems = [...prev];
      const draggedIndex = newItems.findIndex((i) => i.id.toString() === draggedId.toString());
      const targetIndex = newItems.findIndex((i) => i.id.toString() === targetId.toString());

      if (draggedIndex !== -1 && targetIndex !== -1) {
        const temp = newItems[draggedIndex];
        newItems[draggedIndex] = newItems[targetIndex];
        newItems[targetIndex] = temp;
      }
      return newItems;
    });
  };

  // const renderCategoryRow = (catId, displayTitle) => (
  //   <div key={catId} className="category-section">
  //     <h3 className="category-title">{displayTitle}</h3>
  //     <div className="scroll-wrapper" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
  //       <button className="nav-btn left" onClick={() => scroll(catId, 'left')}>‹</button>
  //       <button className="nav-btn right" onClick={() => scroll(catId, 'right')}>›</button>
  //       <div className="menu-items-grid" ref={(el) => (scrollRefs.current[catId] = el)}>
  //         {menuItems
  //           .filter((item) => item.type === catId)
  //           .map((item) => (
  //             <div
  //               key={item.id}
  //               className={`menu-card ${selectedItems.some(i => i.id === item.id) ? 'active' : ''}`}
  //               onClick={() => toggleItem(item)}
  //             >
  //               <img src={item.image} alt={item.name} />
  //               <p>{item.name}</p>
  //             </div>
  //           ))}
  //       </div>
  //     </div>
  //   </div>
  // );
  const renderCategoryRow = (catId, displayTitle) => (
    <div key={catId} className="category-section">
      <h3 className="category-title">{displayTitle.replace(/_/g, ' ')}</h3>
      <div className="slider-container">
        {/* Navigation Buttons - Hidden on mobile via CSS */}
        <button className="nav-btn left" onClick={() => scroll(catId, 'left')}>‹</button>
        <button className="nav-btn right" onClick={() => scroll(catId, 'right')}>›</button>

        <div
          className="menu-items-grid"
          ref={(el) => (scrollRefs.current[catId] = el)}
        >
          {menuItems
            .filter((item) => item.type === catId)
            .map((item) => (
              <div
                key={item.id}
                className={`menu-card ${selectedItems.some(i => i.id === item.id) ? 'active' : ''}`}
                onClick={() => toggleItem(item)}
              >
                <div className="image-box">
                  <img src={item.image} alt={item.name} />
                </div>
                <p>{item.name}</p>
              </div>
            ))}
        </div>
      </div>
    </div>
  );

  return (
    <div className="build-menu-page">
      <div className="main-horizontal-wrapper">
        <div className="left-menu-panel">
          <h2 className="title">Select Your Items</h2>
          {menuStructure.map((section, index) => (
            <div key={index} className="main-section-group">
              <h2 className="main-category-header">{section.title}</h2>
              {section.types && section.types.map((cat) => renderCategoryRow(cat, cat))}
              {section.subSections && section.subSections.map((sub) => renderCategoryRow(sub.type, sub.name))}
            </div>
          ))}
        </div>
        {/* <div className="left-menu-panel">
          <h2 className="title">Select Your Items</h2>
          {menuStructure.map((section, index) => (
            <div key={index} className="main-section-group">
              <h2 className="main-category-header">{section.title}</h2>
             
              <div className="category-row-grid">
                {section.types && section.types.map((cat) => renderCategoryRow(cat, cat))}
                {section.subSections && section.subSections.map((sub) => renderCategoryRow(sub.type, sub.name))}
              </div>
            </div>
          ))}
        </div> */}

        <div className="right-dish-panel">
          <div className="sticky-preview-wrapper">
            <DishPreview
              selectedItems={selectedItems}
              onRemoveItem={removeFromDish}
              onReorder={reorderItems}
            />
            <div className="dish-actions">
              <button className="btn-secondary" onClick={() => history.push("/menu")}>
                <i className="fas fa-arrow-left"></i> Back
              </button>
              <button className="btn-danger" onClick={clearDish}>
                <i className="fas fa-trash"></i> Clear
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuildMenu;